module.exports = __webpack_public_path__ + "static/media/coin2.93298480.png";